import { IAccount } from "@wingspanhq/users/dist/lib/interfaces";

export const selectorAccountNumber = (account: IAccount) =>
  account.numbers?.account;
